import React from 'react';
import ReactDOM from 'react-dom';

import 'athenaeum/lib/assets/styles.css';
import MainNav from '../src/templates/MainNav';

ReactDOM.render(<MainNav />, document.getElementById('nav'));



// WEBPACK FOOTER //
// ./main_nav_entry.js